module.exports = __webpack_public_path__ + "img/1415381407.e29b4aac.jpg";